import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { backend } from '../../axios/backend';
import Spinner from '../../components/ui/Spinner';
import { useAppContext } from '../../context/AppContext';
import { parseErrorMessage } from '../../utils/error-message';

const EmailValidationPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { alertSuccess, alertError, verifyUser } = useAppContext();

  const mutation = useMutation(() => backend.patch(`/auth/verify-email/${token}`), {
    onSuccess: () => {
      alertSuccess('Email erfolgreich validiert.');
      verifyUser();
      navigate('/');
    },
    onError: (e) => {
      alertError(parseErrorMessage(e));
    },
  });

  useEffect(() => {
    mutation.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ margin: '2rem' }} className="space-y-2">
      <h1 className="text-white text-xl">
        <b>Email Adresse validieren</b>
      </h1>
      {mutation.isLoading && <Spinner />}
      {mutation.error && <p className="text-white">Es ist ein Fehler aufgetreten.</p>}
    </div>
  );
};

export default EmailValidationPage;
